import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { DyeingMachine } from '../../models/production/dyeing';
import { AssetSearchCommand } from '../../models/asset/assetSearchCommand';
import { Observable } from 'rxjs';
import { Asset } from '../../models/asset/asset';

import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class AssetProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/asset';

  updateAsset(asset: Asset): Observable<Asset> {
    return this.httpClient.post<Asset>(`${this.baseUrl}`, asset);
  }

  searchAssets(
    searchCommand: AssetSearchCommand,
    pageNumber?: number,
    pageSize?: number,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<Asset>>> {
    const params = new URLSearchParams();
    if (pageNumber !== undefined) params.set('pageNumber', String(pageNumber));
    if (pageSize !== undefined) params.set('pageSize', String(pageSize));
    if (sortField !== undefined) params.set('sortField', sortField);
    if (sortOrder !== undefined) params.set('sortOrder', String(sortOrder));
    const query = params.toString();
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Asset>>>(
      `${this.baseUrl}/search${query ? '?' + query : ''}`,
      searchCommand,
    );
  }

  filterAssets(searchCommand: AssetSearchCommand): Observable<ApiResponse<Asset[]>> {
    return this.httpClient.post<ApiResponse<Asset[]>>(`${this.baseUrl}/filter`, searchCommand);
  }

  getByAssetId(assetId: string): Observable<ApiResponse<Asset>> {
    return this.httpClient.get<ApiResponse<Asset>>(`${this.baseUrl}/${assetId}`);
  }

  getAssets(): Observable<ApiResponse<Asset[]>> {
    return this.httpClient.get<ApiResponse<Asset[]>>(`${this.baseUrl}/all`);
  }

  getAllMachineOptions(): Observable<DyeingMachine[]> {
    const data = {
      assetPrefixReference: '67bdc33b090b4528ccbf3f76',
      assetTypeReference: '',
      assetId: 'DM',
    };

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Asset>>>(`${this.baseUrl}/search`, data).pipe(
      map((res) =>
        (res.data?.items ?? []).flatMap((r) => ({
          maxCapacity: r.assetCapacity?.maxCapacity ?? undefined,
          minCapacity: r.assetCapacity?.minCapacity ?? undefined,
          assetId: r.assetId,
          modelName: r.assetModelName,
          assetType: r.assetTypeName,
          asset: r.assetId,
          numberOfPorts: r.dyeingMachineDetails?.numberOfPorts,
        })),
      ),
    );
  }

  getAllMachineOptionCorrectWay(): Observable<ApiResponse<PaginatedApiResponse<Asset>>> {
    const data = {
      assetPrefixReference: '67bdc33b090b4528ccbf3f76',
      assetTypeReference: '',
      assetId: 'DM',
    };

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Asset>>>(`${this.baseUrl}/search`, data);
  }
}
